export const GET_ANONYMOUS_EXAM_RECORDS = "GET_ANONYMOUS_EXAM_RECORDS"
export const GET_ANONYMOUS_EXAM_RECORDS_FAIL = "GET_ANONYMOUS_EXAM_RECORDS_FAIL"
export const GET_ANONYMOUS_EXAM_RECORDS_SUCCESS = "GET_ANONYMOUS_EXAM_RECORDS_SUCCESS"

export const ADD_NEW_ANONYMOUS_EXAM_RECORD = "ADD_NEW_ANONYMOUS_EXAM_RECORD"
export const ADD_ANONYMOUS_EXAM_RECORD_SUCCESS = "ADD_ANONYMOUS_EXAM_RECORD_SUCCESS"
export const ADD_ANONYMOUS_EXAM_RECORD_FAIL = "ADD_ANONYMOUS_EXAM_RECORD_FAIL"

export const UPDATE_ANONYMOUS_EXAM_RECORD = "UPDATE_ANONYMOUS_EXAM_RECORD"
export const UPDATE_ANONYMOUS_EXAM_RECORD_SUCCESS = "UPDATE_ANONYMOUS_EXAM_RECORD_SUCCESS"
export const UPDATE_ANONYMOUS_EXAM_RECORD_FAIL = "UPDATE_ANONYMOUS_EXAM_RECORD_FAIL"

export const DELETE_ANONYMOUS_EXAM_RECORD = "DELETE_ANONYMOUS_EXAM_RECORD"
export const DELETE_ANONYMOUS_EXAM_RECORD_SUCCESS = "DELETE_ANONYMOUS_EXAM_RECORD_SUCCESS"
export const DELETE_ANONYMOUS_EXAM_RECORD_FAIL = "DELETE_ANONYMOUS_EXAM_RECORD_FAIL"



export const GET_ANONYMOUS_RECORDS_FOR_TEACHER = "GET_ANONYMOUS_RECORDS_FOR_TEACHER";
export const GET_ANONYMOUS_RECORDS_FOR_TEACHER_SUCCESS = "GET_ANONYMOUS_RECORDS_FOR_TEACHER_SUCCESS";
export const GET_ANONYMOUS_RECORDS_FOR_TEACHER_FAIL = "GET_ANONYMOUS_RECORDS_FOR_TEACHER_FAIL";



// LAST ADD FOR SEARCH BY BARCODE
export const GET_ANONYMOUS_EXAM_RECORD_BY_BARCODE = "GET_ANONYMOUS_EXAM_RECORD_BY_BARCODE";
export const GET_ANONYMOUS_EXAM_RECORD_BY_BARCODE_SUCCESS = "GET_ANONYMOUS_EXAM_RECORD_BY_BARCODE_SUCCESS";
export const GET_ANONYMOUS_EXAM_RECORD_BY_BARCODE_FAIL = "GET_ANONYMOUS_EXAM_RECORD_BY_BARCODE_FAIL";

export const UPDATE_ANONYMOUS_EXAM_RECORD_NOTE = "UPDATE_ANONYMOUS_EXAM_RECORD_NOTE";
export const UPDATE_ANONYMOUS_EXAM_RECORD_NOTE_SUCCESS = "UPDATE_ANONYMOUS_EXAM_RECORD_NOTE_SUCCESS";
export const UPDATE_ANONYMOUS_EXAM_RECORD_NOTE_FAIL = "UPDATE_ANONYMOUS_EXAM_RECORD_NOTE_FAIL";


// FOR GENERATE ANONYMOUS RECORDS
export const GENERATE_ANONYMOUS_RECORDS = "GENERATE_ANONYMOUS_RECORDS";
export const GENERATE_ANONYMOUS_RECORDS_SUCCESS = "GENERATE_ANONYMOUS_RECORDS_SUCCESS";
export const GENERATE_ANONYMOUS_RECORDS_FAIL = "GENERATE_ANONYMOUS_RECORDS_FAIL";





